<section class="cr-static cr-kontakt-page">
  <div class="cr-static__inner">
    <header class="cr-static__hero">
      <span class="cr-static__eyebrow">Kontakt</span>
      <h1 class="cr-static__title">
        Wie können wir helfen?
      </h1>
      <p class="cr-static__lead">
        Du suchst Hilfe als Kunde oder Handwerker?
        <a routerLink="/hilfe" class="cr-kontakt-page__hint-link">
          Bitte über die Hilfe-Seite kontaktieren →
        </a>
        Dort findest du auch Antworten auf die häufigsten Fragen.
      </p>
    </header>

    <section class="cr-kontakt-page__cards" aria-label="Kontakt-Kategorien">
      <h2 class="cr-static__h2">Direkt-Adressen</h2>

      <div class="cr-kontakt-page__grid">
        @for (k of kategorien; track k.title) {
          <article class="cr-kontakt-page__card">
            <div class="cr-kontakt-page__card-icon" aria-hidden="true">
              @switch (k.icon) {
                @case ('mail') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="5" width="18" height="14" rx="2"/>
                    <path d="M3 7l9 6 9-6"/>
                  </svg>
                }
                @case ('press') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 22V6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v14"/>
                    <path d="M19 22a2 2 0 0 0 2-2v-7h-2"/>
                    <path d="M8 8h7M8 12h7M8 16h5"/>
                  </svg>
                }
                @case ('partner') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="8" r="3"/>
                    <circle cx="17" cy="10" r="2.5"/>
                    <path d="M3 20c0-3 3-5 6-5s6 2 6 5"/>
                    <path d="M14 20c0-2 2-3.5 4-3.5s4 1.5 4 3.5"/>
                  </svg>
                }
                @case ('shield') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/>
                    <path d="M9 12l2 2 4-4"/>
                  </svg>
                }
                @case ('gavel') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 7l3-3 4 4-3 3z"/>
                    <path d="M11 10l3 3-7 7-3-3z"/>
                    <path d="M3 21h12"/>
                  </svg>
                }
                @case ('flag') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
                       stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M4 21V4h12l-2 4 2 4H4"/>
                  </svg>
                }
              }
            </div>
            <h3 class="cr-kontakt-page__card-title">{{ k.title }}</h3>
            @if (k.email) {
              <a [href]="'mailto:' + k.email" class="cr-kontakt-page__card-email">
                {{ k.email }}
              </a>
            }
            @if (k.link) {
              <a [routerLink]="k.link.route" class="cr-kontakt-page__card-email">
                {{ k.link.label }}
              </a>
            }
            @if (k.hint) {
              <p class="cr-kontakt-page__card-hint">{{ k.hint }}</p>
            }
          </article>
        }
      </div>
    </section>

    <section class="cr-kontakt-page__form-block" aria-label="Kontaktformular">
      <h2 class="cr-static__h2">Kontaktformular</h2>
      <p class="cr-kontakt-page__form-lead">
        Für sonstige Anliegen — wir antworten werktags innerhalb von 24 Stunden.
      </p>

      @if (status() === 'success' && successTicket(); as ticket) {
        <div class="cr-kontakt-page__success">
          <span class="cr-kontakt-page__success-icon" aria-hidden="true">✓</span>
          <div>
            <h3>Wir haben deine Nachricht erhalten.</h3>
            <p>
              Referenz-ID: <code>{{ ticket.id }}</code><br>
              Wir melden uns binnen 24 h werktags an deine angegebene E-Mail-Adresse.
            </p>
          </div>
        </div>
      } @else {
        <form #form="ngForm" (ngSubmit)="onSubmit(form)" class="cr-kontakt-page__form" novalidate>
          <input type="text" name="website" tabindex="-1" autocomplete="off"
                 [(ngModel)]="honeypot" class="cr-kontakt-page__honeypot" aria-hidden="true">

          <div class="cr-kontakt-page__row">
            <label class="cr-kontakt-page__label" for="kontakt-thema">
              Thema <span class="cr-kontakt-page__req">*</span>
            </label>
            <select id="kontakt-thema" name="thema" class="cr-input"
                    [(ngModel)]="thema" required #themaCtrl="ngModel">
              <option value="" disabled>Thema auswählen…</option>
              @for (t of themen; track t.value) {
                <option [value]="t.value">{{ t.label }}</option>
              }
            </select>
            @if (themaCtrl.invalid && themaCtrl.touched) {
              <span class="cr-kontakt-page__err">Bitte wähle ein Thema.</span>
            }
          </div>

          <div class="cr-kontakt-page__row cr-kontakt-page__row--two">
            <div>
              <label class="cr-kontakt-page__label" for="kontakt-name">
                Name <span class="cr-kontakt-page__req">*</span>
              </label>
              <input id="kontakt-name" name="name" type="text" class="cr-input"
                     [(ngModel)]="name" required maxlength="200"
                     #nameCtrl="ngModel">
              @if (nameCtrl.invalid && nameCtrl.touched) {
                <span class="cr-kontakt-page__err">Bitte gib einen Namen an.</span>
              }
            </div>
            <div>
              <label class="cr-kontakt-page__label" for="kontakt-email">
                E-Mail <span class="cr-kontakt-page__req">*</span>
              </label>
              <input id="kontakt-email" name="email" type="email" class="cr-input"
                     [(ngModel)]="email" required maxlength="255" email
                     #emailCtrl="ngModel">
              @if (emailCtrl.invalid && emailCtrl.touched) {
                <span class="cr-kontakt-page__err">Bitte gib eine gültige E-Mail-Adresse an.</span>
              }
            </div>
          </div>

          <div class="cr-kontakt-page__row">
            <label class="cr-kontakt-page__label" for="kontakt-anliegen">
              Anliegen <span class="cr-kontakt-page__req">*</span>
            </label>
            <textarea id="kontakt-anliegen" name="anliegen" class="cr-textarea"
                      [(ngModel)]="anliegen" rows="6" maxlength="2000" required
                      placeholder="Beschreibe dein Anliegen kurz (min. 30 Zeichen)."></textarea>
            <span class="cr-kontakt-page__hint">{{ bodyHint() }}</span>
          </div>

          <div class="cr-kontakt-page__consent">
            <label>
              <input type="checkbox" name="consent" [(ngModel)]="consent" required>
              <span>
                Ich habe die
                <a routerLink="/datenschutz" target="_blank" rel="noopener">Datenschutzerklärung</a>
                zur Kenntnis genommen und stimme der Verarbeitung meiner Daten zur
                Bearbeitung dieser Anfrage zu.
              </span>
            </label>
          </div>

          @if (errorMessage(); as err) {
            <div class="cr-kontakt-page__alert">{{ err }}</div>
          }

          <button type="submit" class="cr-btn cr-btn--primary cr-kontakt-page__submit"
                  [disabled]="status() === 'submitting'">
            @if (status() === 'submitting') { Wird gesendet… } @else { Senden }
          </button>
        </form>
      }
    </section>

    <section class="cr-kontakt-page__post" aria-label="Postanschrift">
      <h2 class="cr-static__h2">Postanschrift</h2>
      <address class="cr-static__address">
        <strong>Kulatrix UG (haftungsbeschränkt)</strong><br>
        Alarichstraße 18<br>
        42281 Wuppertal<br>
        Deutschland<br><br>
        Telefon: <a href="tel:+4915252629106">+49&nbsp;152&nbsp;52629106</a>
      </address>
    </section>
  </div>
</section>
